"use strict";

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var components_1 = require("@lsg/components");

var GridRow_1 = require("@lsg/components/lib/components/atoms/Grid/GridRow");

var GridColumn_1 = require("@lsg/components/lib/components/atoms/Grid/GridColumn");

var react_components_1 = require("@lws/react-components");

var StageCtaButton_1 = require("./StageCtaButton");

var utils_1 = require("../../utils");

var StageHeadline_1 = require("./StageHeadline");

exports.StageLikeComponent = function (_a) {
  var data = _a.data;

  var _b, _c;

  var overline = data.text('overline');
  var headline = data.richText('headline', utils_1.emptyDocument);
  var subline = data.richText('subline', utils_1.emptyDocument);
  var ctaLabel = data.text('ctaLabel');
  var ctaTarget = data.text('ctaTarget');
  return react_1["default"].createElement(components_1.Theme, {
    look: components_1.Themes.LIGHT
  }, react_1["default"].createElement(components_1.Section, null, react_1["default"].createElement(GridRow_1.GridRow, {
    columnVariate: true
  }, react_1["default"].createElement(GridColumn_1.GridColumn, {
    xs: 4,
    sm: 8,
    md: 8
  }, react_1["default"].createElement(components_1.TextSection, {
    label: overline,
    title: react_1["default"].createElement(react_components_1.FootnotesRichtextRenderer, {
      content: headline,
      wrapper: StageHeadline_1.SpanElement
    }),
    titleSize: (_b = components_1.Headline.Sizes) === null || _b === void 0 ? void 0 : _b.H1
  }, react_1["default"].createElement(react_components_1.FootnotesRichtextRenderer, {
    content: subline,
    wrapper: components_1.Paragraph,
    wrapperOptions: {
      size: (_c = components_1.Paragraph.Sizes) === null || _c === void 0 ? void 0 : _c.LEAD
    }
  })), react_1["default"].createElement(StageCtaButton_1.StageCtaButton, {
    label: ctaLabel,
    href: ctaTarget
  })))));
};